import Vue from 'vue'
import hash from 'object-hash'
import { platformMutations } from '~/helpers/store'
import filterMutations from './filters'

export default {
  ...platformMutations,
  ...filterMutations,

  searchFetching: (s, params) => {
    const hashedSearch = hash(params)
    if (hashedSearch && !s.meta.searches[hashedSearch]) {
      const search = {
        fetching: true,
        failed: false,
        errorMessages: [],
        pages: [],
        totalPages: null
      }
      Vue.set(s.meta.searches, hashedSearch, search)
    }
    const search = Object.assign({}, s.meta.searches[hashedSearch])
    search.fetching = true
    Vue.set(s.meta.searches, hashedSearch, search)
  },
  searchFetched: (s, params) => {
    const hashedSearch = hash(params)
    if (s.meta.searches[hashedSearch]) {
      const search = Object.assign({}, s.meta.searches[hashedSearch])
      search.fetching = false
      Vue.set(s.meta.searches, hashedSearch, search)
    }
  },
  searchFailed: (s, { params, failed }) => {
    const hashedSearch = hash(params)
    if (s.meta.searches[hashedSearch]) {
      const search = Object.assign({}, s.meta.searches[hashedSearch])
      search.failed = failed
      Vue.set(s.meta.searches, hashedSearch, search)
    }
  },

  saveSearch: (s, { params, events, meta }) => {
    const { page, totalPages } = meta
    delete params.page
    const hashedSearch = hash(params)

    let search = {
      pages: [],
      totalPages: null
    }
    if (s.meta.searches[hashedSearch]) {
      search = Object.assign({}, s.meta.searches[hashedSearch])
    }
    search.pages[page - 1] = events.map(event => event.id)
    search.totalPages = totalPages

    Vue.set(s.meta.searches, hashedSearch, search)
  },

  inductionEventsFetching: s => {
    s.meta.inductionEventsFetching = true
  },

  inductionEventsFetched: s => {
    s.meta.inductionEventsFetching = false
  },

  happeningNowFetching: s => {
    s.meta.happeningNowFetching = true
  },

  happeningNowFetched: s => {
    s.meta.happeningNowFetching = false
  },

  happeningNowFailed: s => {
    s.meta.happeningNowFetching = false
    s.meta.happeningNowFailed = true
  },

  saveHappeningNow: (s, events) => {
    Vue.set(s.meta.searches, 'happeningNow', events)
  },

  setPastEvents: (s, events) => {
    Vue.set(s.meta.searches, 'pastEvents', events)
  },

  appendPastEvents: (s, events) => {
    Vue.set(s.meta.searches, 'pastEvents', s.meta.searches.pastEvents.concat(events))
  }
}
